import { render } from "./GlobalFilter.vue?vue&type=template&id=73ba4499"
import script from "./GlobalFilter.vue?vue&type=script&lang=js"
export * from "./GlobalFilter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__